type MediaDisplayProps = {
  type: 'video' | 'image';
  url: string;
  description: string;
  id: number;
};

export const MediaDisplay: React.FC<MediaDisplayProps> = ({
  type,
  url,
  description,
  id,
}) => {
  if (type === 'video') {
    return (
      <iframe
        allowFullScreen
        className='h-full w-full'
        src={url}
        title={`Video ${id}`}
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      />
    );
  }

  return (
    <img
      src={url}
      alt={description}
      className='h-full w-full object-cover'
    />
  );
};
